var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.repairEstimate.number'),
      "hint": _vm.$t('objects.repairEstimate.numberHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.number,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "number", $$v);
      },
      expression: "value.number"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": " 12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$t('objects.repairEstimate.currency'),
      "clearable": "",
      "outlined": "",
      "return-object": "",
      "auto-select-first": "",
      "items": Object.values(_vm.CurrencyEnum),
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [e];
      }),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "currency", $$v);
      },
      expression: "value.currency"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('line-items-form', {
    staticClass: "mb-2",
    attrs: {
      "readonly": false,
      "showProducts": false
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.dateLabel'),
      "persistent-hint": "",
      "outlined": "",
      "hint": _vm.$t('components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.dateHint'),
      "clearable": ""
    },
    model: {
      value: _vm.value.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dateFormable", $$v);
      },
      expression: "value.dateFormable"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }